import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { getAllDishes } from './shared/api/user';
import { useState, useEffect } from 'react';
import moment from 'moment';

export default function BasicTable() {
  const [Dishes, setDishes] = useState([]);
  const init = async  () => {
    let rows = await getAllDishes();
    setDishes(rows.data.dishes);
    console.log(rows.data.dishes)
  }
 useEffect(() => {
  init();
 }, []);

  return (
    <TableContainer component={Paper}>
      <Table sx={{ minWidth: 650 }} aria-label="simple table">
        <TableHead>
          <TableRow>
            <TableCell>Dish Name</TableCell>
            <TableCell align="right">Price</TableCell>
            <TableCell align="right">Chef Name</TableCell>
            <TableCell align="right">Cuisine</TableCell>
            <TableCell align="right">Edit Dish</TableCell>
            <TableCell align="right">Delete Dish</TableCell>
            <TableCell align="right">Dish Added Time</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {Dishes.map((row) => (
            <TableRow
              key={row._id}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row">
              {row.dishName}
              </TableCell>
              <TableCell align="right">{`Rs. ${row.price}`}</TableCell>
              <TableCell align="right">{row.user?.firstName} {row.user?.lastName}</TableCell>
              <TableCell align="right">{row.cuisine?.title}</TableCell>
              <TableCell align="right"><Button sx={{ color: '#CB2704' }} variant="text"><EditIcon></EditIcon></Button></TableCell>
              <TableCell align="right"><Button sx={{ color: '#CB2704' }} variant="text"><DeleteIcon></DeleteIcon></Button></TableCell>
              <TableCell align="right">{moment(row.createdAt).format('MMMM Do YYYY, h:mm:ss a')}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}